import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getApplicationsBrownoutWarningMessageApi } from '../api';

export default function useBrownoutWarningMessage(useQueryOptions) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['brownoutWarningMessage'],
    queryFn: () => dispatch(getApplicationsBrownoutWarningMessageApi()),
    ...useQueryOptions,
  });
}
